const defaultState = {
  products: [{"pic":"right", "topic":"", "ad":"数据加载中...", "picurl":"/pics/jcwWS12&690.jpg"}],
  customers: [{"pic":"left", "topic":"青岛玻璃有限公司", "ad":"系统广告语XXXXtop",
            "picurl":"https://p0.ifengimg.com/2019_27/8DDF1A7EABB6927DF3540F756462C59D972F7397_w1080_h606.jpg"}],
  honors: [{"img": "http://www.qdlkd.com/images/index_NewsPic.jpg","topic":"软件产品著作"}],
  contacts: [{"topic":"地址", "txt":"青岛市李沧区虎山路"}],
  lunbo: [{"topic":"", "ad":"数据加载中...", "picurl":"/pics/jcwWS12&690.jpg"}],
  lunbolink: '',
  customerpic:'https://d.ifengimg.com/w1000_h380_q70/p1.ifengimg.com/2019_26/2B5032DCB1847297C23F53374622F25CF589AE4D_w1000_h380.jpg',
  company: {topic:"公司简介", ad: "/pics/stand.png",
        context: [{imgurl: "http://e0.ifengimg.com/05/2019/0701/267FA435880D57DBD6A14237D9C576B6C6BB13B8_size42_w1080_h569.jpeg",
        desc: "context context" }] }
};
export default (state=defaultState,action)=>{
  if(action.type === 'get_lkd'){
    const newState = JSON.parse(JSON.stringify(state));
    newState.products  = action.value.products;
    newState.honors    = action.value.honors;
    newState.customers = action.value.customers;
    newState.contacts  = action.value.contacts;
    newState.contactad = action.value.contactad;
    newState.lunbo     = action.value.lunbo;
    newState.lunbolink = action.value.lunbolink;
    newState.customerpic = action.value.customerpic;
    newState.company   = action.value.company;
    return newState;
  }
  if(action.type === 'get_products'){
    const newState = JSON.parse(JSON.stringify(state));
    newState.products = action.value;
    return newState;
  }
  if(action.type === 'get_custemers'){
    const newState = JSON.parse(JSON.stringify(state));
    newState.custemers = action.value;
    return newState;
  }
  if(action.type === 'get_honors'){
    const newState = JSON.parse(JSON.stringify(state));
    newState.honors = action.value;
    return newState;
  }
  if(action.type === 'get_contacts'){
    const newState = JSON.parse(JSON.stringify(state));
    newState.contacts = action.value;
    return newState;
  }
  return state;
}